import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../CustomModule.css';
import { imageUrl as ImageUrl } from '../../../../../Components/helper';

export function ImageControl({
  imageUrl,
  fromForm,
  duplicatingItem,
  editingInput,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
}) {
  const { t } = useTranslation('common');

  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const filePreview = () => {
    return imageUrl ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${imageUrl}`) : '';
  };

  let logo = null;
  if (imageUrl.includes('base64')) {
    logo = imageUrl;
  } else {
    logo = `${ImageUrl}/${imageUrl}`;
  }

  return (
    <div className="position-relative h-100 text-center">
      <p className="image-control-canvas">
        {onElement && (
          <button
            type="button"
            className="btn btn-border btn-upload-image ml-auto fs-custom-module py-0 px-1"
            onClick={() => editingInput(gridIndex, pageIndex)}
          >
            {imageUrl === '' ? t('CUSTOM_MODULE.UPLOAD') : t('CUSTOM_MODULE.UPDATE')} {t('CUSTOM_MODULE.IMAGE')}&nbsp;
            <span className="icon-upload" />
          </button>
        )}
      </p>
      {imageUrl !== '' && <img src={imageUrl.includes('base64') ? logo : filePreview()} className="img-fluid" alt="" />}

      {fromForm && onElement && (
        <div className="potemp-action-btns">
          {showDelete && (
            <button aria-label="Delete" type="button" className="btn btn-border py-0 px-1" onClick={() => deleteItem(gridIndex, pageIndex)}>
              <span className="icon-delete" />
            </button>
          )}
          <button aria-label="Copy" type="button" className="btn btn-border py-0 px-1" onClick={() => handleDuplicateItem()}>
            <span className="icon-copy" />
          </button>
          <button
            aria-label="Active/Inactive Supplier"
            type="button"
            className={`btn btn-border py-0 px-1 ${supplierVisible ? 'text-success' : 'text-danger'}`}
            onClick={() => handleSupplierPermission(gridIndex, pageIndex)}
          >
            <span className="icon-active" />
          </button>
          <button
            aria-label="Static"
            type="button"
            className={`btn btn-border py-0 px-1 ${isStatic && 'text-danger'}`}
            onClick={() => handleStaticGrid(gridIndex, pageIndex)}
          >
            <span className="icon-lock" />
          </button>
        </div>
      )}
    </div>
  );
}
export default ImageControl;
